<template>
  <div class="row">
    <div class="col-lg">
      <modal :show.sync="show" style="z-index: 9999;">
        <div class="modal-header"
          style="margin: -25px -24px 0px -24px; padding: 20px 40px 20px 40px; background-color: #15cf79;">
          <div class="col-lg"></div>
          <div class="col-lg-5">
            <div style="padding: 15px; background-color: transparent; border-radius: 100px; border: 10px solid white;">
              <i style="color: white; font-size: 90px; font-weight: 900" class="tim-icons icon-check-2"></i>
            </div>
            <div>
              <p style="color: white; font-size: 17px; text-align: center; font-weight: 500;">
                Successful
              </p>
            </div>
          </div>
          <div class="col-lg"></div>
        </div>
        <div class="col-lg-12 text-center">
          <p style="margin-top: 50px; font-size: 40px; font-weight: 500; color: #707070;">
            {{ title }}
          </p>
          <p style="color: #A5A5A5">{{ message }}</p>
          <div class="col-lg-12 text-center" style="margin-bottom: 50px">
            <base-button type="primary" @click="closeModal">Okay</base-button>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>

import { Modal } from "src/components";

export default {
  name: 'StatusModal',
  components: {
    Modal,
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    }
  },
  methods: {
    closeModal() {
      this.$emit('update:show', false);
    }
  }
};
</script>